export default __webpack_public_path__ + "images/shopify-logo.png";